import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 py-6 mt-auto" data-testid="app-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="text-sm text-[#86868B]">&copy; {new Date().getFullYear()} Zelvrix. All rights reserved.</span>
        <nav className="flex items-center gap-5 text-sm">
          <Link to="/terms-and-conditions" className="text-[#86868B] hover:text-[#1D1D1F] transition-colors" data-testid="footer-terms-link">
            Terms of Service
          </Link>
          <Link to="/privacy-policy" className="text-[#86868B] hover:text-[#1D1D1F] transition-colors" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" className="text-[#86868B] hover:text-[#1D1D1F] transition-colors" data-testid="footer-cookie-link">
            Cookie Policy
          </Link>
        </nav>
      </div>
    </footer>
  );
}
